var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-bar",style:(_vm.styles)},[_vm._t("icon"),_c('div',{staticClass:"d-flex align-items-center justify-content-between w-100 h-100"},[_vm._t("left"),_vm._t("center"),_vm._t("right")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }